import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_ORANGE,
    codeProp: 'brfCode',
    mapProp: 'brfMap',
    name: '结构化需求单',
    ownerTextProp: 'prjName',
    textProp: 'brfTitle',
    type: 'BRF',
}
